// extracted by mini-css-extract-plugin
export var cardFigure = "_8-0";
export var cardImage = "_8-2";
export var cardInner = "_8-1";
export var cardLabel = "_8-3";
export var cardPill = "_8-4";
export var cardPillActive = "_8-6";
export var cardPillSelfServe = "_8-7";
export var cardPillText = "_8-5";
export var pillGlow = "_8-8";
export var pillShimmer = "_8-9";